import React from "react";
import Container from "react-bootstrap/Container";
import { colors } from "utils/styles";
import Text from "./Text";
import DynamicLink from "./DynamicLink";
import Title from "./Title";

export default function jobPostings({ jobPostings }) {
	return (
		<Container>
			{jobPostings.items.map((jobPosting) => {
				const id = jobPosting.sys.id;
				const fields = jobPosting.fields;
				return (
					<React.Fragment key={id}>
						<DynamicLink href={`/aapl-jobs/${id}`}>
							<Title elem="h3" color={colors.darkBlue} text={fields.jobTitle} />
						</DynamicLink>
						<br />
						<Text size="12px" marginBottom={0} text={`Posted: ${fields.postedDate}`} />
						<br />
						<Text size="12px" marginBottom={0} text={`Closing: ${fields.closingDate}`} />
					</React.Fragment>
				);
			})}
		</Container>
	);
}
